module.exports = __webpack_public_path__ + "img/Mocha Frappe.7bd325fe.svg";